// import { loginTokenHeader } from '../../auth-header';
import axios from "../Axios";
import { userApi } from "../../api";

//Get General Setting api
export const getGlobalSettingApiCall = async () => {
  return await axios.get(userApi.globalSetting);
};
